export const saveStateSlotsLocalStorageKey = 'currentSaveStateSlots';
export const virtualControlsLocalStorageKey = 'areVirtualControlsEnabled';
export const virtualControlProfilesLocalStorageKey = 'virtualControlProfiles';
